import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import Selectable from "./Forms/Form_Elements/Selectable";
import ListItemUser from "./ListItemsUser";
import GroupActions from "../UI_Elements/GroupActions";

class List extends Component {


    render() {
        return (
            <div className="List">
                {
                    this.props.stations.map((station, key) => {
                        return (

                            <Collapsible
                                transitionTime={100}
                                easing='ease-out'
                                trigger={
                                <div>
                                    <Selectable title={station.name} stationType={station.type} />
                                    <GroupActions group={station}/>
                                </div>
                                }
                                key={key}
                                open={station.selected}
                            >
                                {
                                    station.users.map((user, key) => {
                                        return (
                                            <ListItemUser user={user} key={key}/>
                                        )
                                    })
                                }

                                {
                                    station.wheelChangers.map((wheelchanger, key) => {
                                        wheelchanger.stationId = station.id;
                                        return (
                                            <div className="level-2" key={key}>
                                                <Collapsible
                                                    key={key}
                                                    transitionTime={100}
                                                    easing='ease-out'
                                                    trigger=
                                                        {
                                                        <div>
                                                            <Selectable stationType={5} title={wheelchanger.name} />
                                                            <GroupActions group={wheelchanger}/>
                                                        </div>
                                                    }
                                                >
                                                    {
                                                        wheelchanger.users.map((user, key) => {
                                                            return (
                                                                <div className="level-3" key={key}>
                                                                    <ListItemUser user={user} key={key} className={"wheel-changer-user"}/>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </Collapsible>
                                            </div>
                                        )
                                    })
                                }
                            </Collapsible>
                        )
                    })
                }
            </div>
        );
    }
}

export default List;


// WEBPACK FOOTER //
// ./src/components/UI_Elements/List.js